// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1n5S9","form":"Search_form__2Sfz0","input":"Search_input__158IR","filter":"Search_filter__2FQUh"};